import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const InstaGalleryLoadable = Loadable({
    loader: () => import('desktop/components/YotpoWidgets/InstaGallery.js' /* webpackChunkName: 'yotpoInstaGallery' */).then(module => module.default),
    loading: () => <Loader />
});

export default InstaGalleryLoadable;
